export const DEFAULT_ENTRA_EMAIL_DOMAINS = ['neuronsolutions.my', 'ytl.com.my'] as const

let cachedEntraDomains: string[] = [...DEFAULT_ENTRA_EMAIL_DOMAINS]

export function setEntraEmailDomains(domains: string[] | undefined | null): void {
  const normalized = (domains ?? [])
    .map((domain) => domain.trim().toLowerCase().replace(/^@+/, ''))
    .filter(Boolean)
  cachedEntraDomains = normalized.length > 0 ? [...new Set(normalized)] : [...DEFAULT_ENTRA_EMAIL_DOMAINS]
}

export function getEntraEmailDomains(): string[] {
  return cachedEntraDomains
}

export function formatAllowedEntraDomains(domains: string[] = cachedEntraDomains): string {
  return domains.map((domain) => `@${domain}`).join(' or ')
}

export function isAllowedEntraEmailDomain(email: string, domains: string[] = cachedEntraDomains): boolean {
  const domain = email.trim().toLowerCase().split('@')[1]
  return !!domain && domains.includes(domain)
}

export function getEntraEmailDomainError(domains: string[] = cachedEntraDomains): string {
  return `Entra ID accounts must use an ${formatAllowedEntraDomains(domains)} email address`
}

export function getEntraEmailPlaceholder(domains: string[] = cachedEntraDomains): string {
  return domains.map((domain) => `name@${domain}`).join(' or ')
}
